import { __awaiter, __generator } from "tslib";
import { isAxiosError } from "axios";
var AxiosUtils = /** @class */ (function () {
    function AxiosUtils() {
    }
    /**
     * Awaits an axios promise and returns an object indicating success or failure.
     * @param filter Only errors matching this filter will be caught.
     */
    AxiosUtils.catchErrors = function (request, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var waited, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 5]);
                        return [4 /*yield*/, request];
                    case 1:
                        waited = _a.sent();
                        return [2 /*return*/, {
                                data: waited.data,
                                success: true,
                            }];
                    case 2:
                        e_1 = _a.sent();
                        if (!isAxiosError(e_1)) return [3 /*break*/, 4];
                        if (!(filter === undefined || filter(e_1.response))) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.readError(e_1)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: throw e_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /** Reads the properties of an axios error. */
    AxiosUtils.readError = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var data, isServerError;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data;
                        if (!data) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ensureAxiosErrorData(data)];
                    case 1:
                        data = _c.sent();
                        _c.label = 2;
                    case 2:
                        isServerError = false;
                        if ((_b = e.response) === null || _b === void 0 ? void 0 : _b.status) {
                            isServerError = this.isServerError(e.response);
                        }
                        return [2 /*return*/, {
                                success: false,
                                isServerError: isServerError,
                                isNetworkError: e.response === undefined,
                                data: data,
                                error: e,
                            }];
                }
            });
        });
    };
    /**
     * Checks if the error data is a blob object, and reads from it if that is the case.
     */
    AxiosUtils.ensureAxiosErrorData = function (responseData) {
        return __awaiter(this, void 0, void 0, function () {
            var errorText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(responseData instanceof Blob)) return [3 /*break*/, 2];
                        return [4 /*yield*/, responseData.text()];
                    case 1:
                        errorText = _a.sent();
                        if (responseData.type.toLowerCase().includes('json')) {
                            return [2 /*return*/, JSON.parse(errorText)];
                        }
                        else {
                            return [2 /*return*/, errorText];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, responseData];
                }
            });
        });
    };
    AxiosUtils.isClientError = function (response) {
        return response !== undefined && response.status >= 400 && response.status < 500;
    };
    AxiosUtils.isServerError = function (response) {
        return response !== undefined && response.status >= 500 && response.status < 600;
    };
    /** Returns true if the error was raised from axios, and is a network error. E.g. no response was received from the server. */
    AxiosUtils.isNetworkError = function (e) {
        return isAxiosError(e) && e.response === undefined;
    };
    return AxiosUtils;
}());
export default AxiosUtils;
